import { ArrowUpRight } from "lucide-react";
import { BUSINESS } from "@/lib/business";

const WORK = [
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/wxqtuoy3_Screenshot_20260531_192023_Facebook.jpg",
    title: "Kitchen Downlights",
    tag: "Lighting Install",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/0qpiaj1o_Screenshot_20260531_192033_Facebook.jpg",
    title: "Consumer Unit Upgrade",
    tag: "Fuse Board",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/9achz7l3_Screenshot_20260531_192105_Facebook.jpg",
    title: "Swimming Pool LED Lights",
    tag: "Commercial",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/kjs004qs_Screenshot_20260531_192038_Facebook.jpg",
    title: "New Consumer Unit",
    tag: "Rewire",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/a0raawoe_Screenshot_20260531_192051_Facebook.jpg",
    title: "Pendant Light Install",
    tag: "Lighting",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/j9ut9na3_Screenshot_20260531_192140_Facebook.jpg",
    title: "Outdoor Pergola Wall Lights",
    tag: "Exterior Lighting",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/wz5z9qgt_Screenshot_20260531_192143_Facebook.jpg",
    title: "House Number & Porch Light",
    tag: "Exterior",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/x9yjs5en_Screenshot_20260531_192124_Facebook.jpg",
    title: "Garage Power & Lighting",
    tag: "Outbuilding",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/ovirbeeg_Screenshot_20260531_192137_Facebook.jpg",
    title: "Socket Circuit Install",
    tag: "Rewire",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/dxm15qma_Screenshot_20260531_195715_Facebook.jpg",
    title: "LED Strip Light Fitting",
    tag: "Lighting",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/keb3sbcw_Screenshot_20260602_080159_Gallery.jpg",
    title: "Commercial Fit-Out & TV Socket Install",
    tag: "Commercial",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/fj49mowk_Screenshot_20260602_080026_Gallery.jpg",
    title: "Pendant Replaced with Chandelier",
    tag: "Feature Lighting",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/5o9z5efh_Screenshot_20260602_080128_Gallery.jpg",
    title: "Wall Sconce Mood Lighting",
    tag: "Interior Lighting",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/uutxi27q_Screenshot_20260602_080132_Gallery.jpg",
    title: "Bathroom Downlight Layout",
    tag: "Bathroom",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/vntnl96u_Screenshot_20260602_080138_Gallery.jpg",
    title: "Feature Alcove Spotlights",
    tag: "Lighting Design",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/gn5zmigy_Screenshot_20260602_080102_Gallery.jpg",
    title: "New Fuse Board Install",
    tag: "Fuse Board",
    span: "lg:col-span-2",
  },
];

export const Gallery = () => (
  <section
    id="work"
    data-testid="gallery-section"
    className="relative bg-[#0A0A0A] py-28 lg:py-36"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#1E90FF]">
              Recent Work
            </span>
            <span className="h-px w-12 bg-[#1E90FF]/40" />
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl text-white font-semibold leading-[1.05] tracking-tight max-w-3xl"
            style={{ fontFamily: "Outfit" }}
          >
            A snapshot of jobs
            <br />
            <span className="text-[#A0AAB2] italic font-light">recently completed.</span>
          </h2>
        </div>
        <a
          href={BUSINESS.facebook}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="gallery-facebook-link"
          className="inline-flex items-center gap-2 text-sm text-[#A0AAB2] hover:text-[#1E90FF] transition-colors"
        >
          See more on Facebook <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] sm:auto-rows-[240px] gap-3">
        {WORK.map((w, i) => (
          <div
            key={i}
            data-testid={`gallery-item-${i}`}
            className={`group relative overflow-hidden bg-[#0F0F0F] cursor-pointer ${w.span || ""}`}
          >
            <img
              src={w.src}
              alt={w.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-110 grayscale-[40%] group-hover:grayscale-0"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
            <div className="absolute inset-0 p-5 flex flex-col justify-end">
              <div className="text-[10px] tracking-[0.25em] text-[#1E90FF] uppercase mb-1">
                {w.tag}
              </div>
              <div className="text-white font-medium text-lg leading-tight" style={{ fontFamily: "Outfit" }}>
                {w.title}
              </div>
            </div>
            <div className="absolute top-4 right-4 w-8 h-8 border border-white/20 flex items-center justify-center opacity-0 group-hover:opacity-100 group-hover:bg-[#1E90FF] group-hover:border-[#1E90FF] transition-all duration-300">
              <ArrowUpRight className="w-3.5 h-3.5 text-white" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
